import { themeTools } from "native-base"

const roundingProps = [
    "rounded",
    "roundedTop",
    "roundedBottom",
    "roundedLeft",
    "roundedRight",

    "roundedTopLeft",
    "roundedTopRight",
    "roundedBottomLeft",
    "roundedBottomRight",
]

export const extractSpacingProps = (props) => {
    return themeTools.extractInObject(props, [
        "space", 
        ...themeTools.stylingProps.padding,
        ...themeTools.stylingProps.margin,
    ])
}

export const extractFlexProps = (props) => {
    return themeTools.extractInObject(props, [
        ...themeTools.stylingProps.flexbox,
    ])
}


export const extractBorderProps = (props) => {
    return themeTools.extractInObject(props, [
        ...themeTools.stylingProps.border,
    ])
}



export const extractLayoutProps = (props) => {
    return themeTools.extractInObject(props, [
        ...themeTools.stylingProps.layout,
        ...themeTools.stylingProps.flexbox,
        ...themeTools.stylingProps,position,
    ])
}

export const extractBackgroundProps = (props) => {
    return themeTools.extractInObject(props, [
        ...themeTools.stylingProps.background,
    ])
}

export const extractRoundingProps = (props) => {
    return themeTools.extractInObject(props, roundingProps)
}


export const extractNativeProps = (props) => {
    const stylingProps = themeTools.stylingProps
    return themeTools.extractInObject(props, [
        "space", 
        "colorScheme",
        ...stylingProps.padding,
        ...stylingProps.margin,
        ...stylingProps.border,
        ...stylingProps.layout,
        ...stylingProps.flexbox,
        ...stylingProps.position,
        ...stylingProps.background,
        ...roundingProps
    ])
}